import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, signInWithCustomToken } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC8_gktk0aJUj1JYZIm6fqQ0Zd2LoUS70M",
  authDomain: "doglingoai.firebaseapp.com",
  projectId: "doglingoai",
  storageBucket: "doglingoai.firebasestorage.app",
  messagingSenderId: "242724520703",
  appId: "1:242724520703:web:ed51b9abae147fd538c2ca",
  measurementId: "G-BEQ2CM6EXM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

// Add error handling for Firebase initialization
if (!app) {
  console.error('Firebase app initialization failed');
}
if (!auth) {
  console.error('Firebase auth initialization failed');
}
if (!firestore) {
  console.error('Firebase firestore initialization failed');
}

// Initialize Analytics safely
let analytics;
try {
  analytics = getAnalytics(app);
  console.log('firebase.js: Analytics initialized successfully');
} catch (error) {
  console.warn('firebase.js: Analytics initialization failed:', error);
  analytics = null;
}

// Set auth persistence
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("Firebase auth persistence set to browserLocalPersistence"))
  .catch((error) => console.error("Error setting Firebase auth persistence:", error));

// Safe logEvent function
const safeLogEvent = (...args) => {
  const [firstArg, secondArg, thirdArg] = args;
  const eventName = typeof firstArg === "string" ? firstArg : secondArg;
  const eventParams = typeof firstArg === "string" ? secondArg : thirdArg;

  try {
    if (!eventName) return;

    if (analytics) {
      firebaseLogEvent(analytics, eventName, eventParams);
    } else {
      console.log(`Mock logEvent: ${eventName}`, eventParams);
    }
  } catch (error) {
    console.error("Error logging event:", error);
  }
};

export { app, auth, firestore, storage, analytics, safeLogEvent as logEvent, signInWithCustomToken };
